import styled from 'styled-components';

export const Contain = styled.div`
  height: 100%;
  width: 98%;
  margin: auto;
  padding-bottom: 120px;
  section {
    padding: 0 5px;
  }
  #ComponenteInputDropdown {
    padding: 30px 0 10px 0;
  }
  #exibirEditorTexto {
    margin-top: 6px !important;
    padding: 0px 10px 10px 15px !important;
    font-size: 9pt;
  }
`;

export const ContainButton = styled.div`
  width: 98%;
  margin: auto;
  margin-top: 20px;
  button {
    margin-left: auto;
  }
`;

export const ContainButtonEdit = styled.div`
  margin-top: 20px;
  margin-left: auto;
  button {
    margin-left: auto;
  }
`;
